<script>
    import Groups from './Groups.svelte';
    import Users from './Users.svelte';
    let mode = "";
    $: display = mode ? mode.split('-')[1] : '';

</script>
<div id="admin-container">
    <section id="menu">
        menu
        <h1>Users</h1>
        <ul>
            <li on:click={()=> mode = 'users-view' }>View</li>
            <li on:click={()=> mode = 'users-add' }>Add</li>
        </ul>
        <h1>Groups</h1>
        <ul>
            <li on:click={()=> mode = 'groups-view' }>View</li>
            <li on:click={()=> mode = 'groups-add' }>Add</li>
        </ul>
        <h1>YouTube</h1>
        <ul>
            <li>View Tokens</li>
            <li>Add Tokens</li>
        </ul>
    </section>
    <main>
        Admin section
        {#if mode.includes('users')}
            <Users {display} />
        {:else if mode.includes('groups')}
            <Groups {display} />
        {/if}
            
    </main>
</div>

<style>
    #admin-container {
        display: grid;
        /* place-items: center; */
        grid-template-columns: auto 1fr;
        /* height: 95vh; */
        width: 100%;
    }
    #menu {
        margin-top: 100px;
        position: sticky;
        top: 70px;
        height: fit-content;
    }
    li {
        text-align: left;
        cursor:pointer;
    }
</style>